"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIterableInstanceDeps = updateIterableInstanceDeps;
const trace_deps_1 = require("../utils/trace-deps");
function updateIterableInstanceDeps(expressions, reference) {
    for (const exp of expressions) {
        for (const expDep of (0, trace_deps_1.traceDepsToExpressions)(exp.dependencies, reference)) {
            for (const [iterableName, iterableInstanceDep] of Object.entries(expDep.iterableInstanceDeps)) {
                if (iterableInstanceDep === "all") {
                    exp.iterableInstanceDeps[iterableName] = "all";
                }
            }
        }
    }
}
//# sourceMappingURL=update-iterable-instance-deps.js.map